// The files in the platform agent's message box (D6, docs/platform-agent/contracts.md §8). The label, placeholder
// and hint stay in PlatformAgentConversation's `composer`.
export default {
  drop: 'Trageți fișierele aici: PDF, fotografii, Excel, CSV sau Word',
  waiting: 'Trimiterea așteaptă până când fișierele sunt încărcate.',
  // A message sent while New chat is starting waits for the new chat (QA90).
  starting: 'Un moment: se pornește chatul nou, iar mesajul tău ajunge acolo.',
  // A message that waits for the person to deal with a file that can't go with it (QA121).
  blocked: {
    refused: 'Elimină fișierul care nu poate fi trimis, apoi trimite mesajul.',
    failed: 'Încearcă din nou încărcarea fișierului sau elimină-l, apoi trimite mesajul.',
  },
  // A PDF's pages on its tile (B37): "PDF · 1.2 MB · 4 pages".
  pages_one: '{{count}} pagină',
  pages_few: '{{count}} pagini',
  pages_other: '{{count}} de pagini',
  problems: {
    type: 'Acest tip de fișier nu poate fi trimis. Trimiteți un PDF, o fotografie (JPG, PNG sau HEIC) ori un fișier Excel, CSV sau Word.',
    size: 'Peste 20 MB. Un fișier poate avea cel mult 20 MB.',
    empty: 'Acest fișier este gol.',
    count: 'Cel mult 10 fișiere per mesaj.',
    upload: 'Încărcarea s-a oprit. Încercați din nou.',
  },
};
